import { render, staticRenderFns } from "./AcademyReport.vue?vue&type=template&id=30098482&scoped=true&"
import script from "./AcademyReport.vue?vue&type=script&lang=js&"
export * from "./AcademyReport.vue?vue&type=script&lang=js&"
import style0 from "./AcademyReport.vue?vue&type=style&index=0&id=30098482&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30098482",
  null
  
)

export default component.exports